/** The Preferences section ids alone, free of icons, so address parsing can validate a slug without loading the UI. */
export const PREFERENCE_SECTION_IDS = [
  'availability',
  'notifications',
  'priority-contacts',
  'navigation',
  'appearance',
  'messages',
  'region',
  'accessibility',
  'mark-as-read',
  'privacy',
  'advanced',
] as const;

export type PreferenceSectionId = typeof PREFERENCE_SECTION_IDS[number];

export function isPreferenceSectionId(value: string | null | undefined): value is PreferenceSectionId {
  return !!value && (PREFERENCE_SECTION_IDS as readonly string[]).includes(value);
}
